import { lastIndexOf } from 'lodash';
import {
  SUPPORTED_TYPES,
  VIDEO_FILE,
  AUDIO_FILE,
  IMAGE_FILE,
  FILE_TYPE_MAP,
  SUPPORTED_SIZES,
  SUPPORTED_DURATIONS,
  SVG_FILE,
  SIZE,
} from './constants';

export const getFileExtension = (filePath) => {
  if (!filePath) {
    return null;
  }
  return filePath.toString().substr(lastIndexOf(filePath, '.')).toLowerCase();
};

export const isMediaAudio = (media = {}) => media.type === AUDIO_FILE;

export const isMediaVideo = (media = {}) => media.type === VIDEO_FILE;

export const isMediaImage = (media = {}) => media.type === IMAGE_FILE;

export const getHtmlFileType = ({ url, type = VIDEO_FILE }) => {
  let fileExtension = getFileExtension(url);

  if (type === AUDIO_FILE && fileExtension === '.mp4') {
    fileExtension = '.mp3';
  }
  return FILE_TYPE_MAP[fileExtension];
};

export const getSupportedMedia = (supportedMediaTypes = []) => {
  const validTypes = [VIDEO_FILE, AUDIO_FILE, IMAGE_FILE, SVG_FILE];
  const requestedValidTypes = supportedMediaTypes.filter((type) =>
    validTypes.includes(type),
  );

  if (requestedValidTypes.length === 0) {
    return undefined;
  }

  return requestedValidTypes.map((type) => SUPPORTED_TYPES[type]);
};

export const getFileType = (file) => {
  const fileExtension = getFileExtension(file.name);

  if (SUPPORTED_TYPES[IMAGE_FILE].includes(fileExtension)) {
    return IMAGE_FILE;
  }
  if (SUPPORTED_TYPES[AUDIO_FILE].includes(fileExtension)) {
    return AUDIO_FILE;
  }
  if (SUPPORTED_TYPES[VIDEO_FILE].includes(fileExtension)) {
    return VIDEO_FILE;
  }
  if (SUPPORTED_TYPES[SVG_FILE].includes(fileExtension)) {
    return SVG_FILE;
  }
  return null;
};

export const isValidFileSize = ({ fileType, size }) =>
  size / 1024 / 1024 < SUPPORTED_SIZES[fileType];

// TODO: for avi, mkv, flv files, we can't calculate the duration of a video
// an appropriate solution is to calculate the duration on server
export const isValidDuration = ({ file, fileType }) => {
  const durationPromise = new Promise((resolve, reject) => {
    const mediaType = fileType === AUDIO_FILE ? AUDIO_FILE : VIDEO_FILE;
    const mediaFile = document.createElement(mediaType);
    mediaFile.preload = 'metadata';
    mediaFile.onloadedmetadata = (event) => {
      const { duration } = event.currentTarget;
      document.body.removeChild(mediaFile);

      if (SUPPORTED_DURATIONS[fileType] >= duration) {
        return resolve(true);
      }

      return reject(new Error('File duration too long'));
    };
    mediaFile.src = URL.createObjectURL(file);
    document.body.appendChild(mediaFile);
  });

  return durationPromise;
};

export function getMaxWidth(size) {
  if (size === SIZE.FULL || size === SIZE.MIDDLE) {
    return null;
  }

  return { maxWidth: size === SIZE.SMALL ? 150 : 300 };
}
